import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { StringFormatter } from '@repo/toolkit/string'
import DataTable from '@repo/ui/data-table'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getOlOtherContacts } from '../../../../api/ols/get-ol-other-contacts'
import { OlLight } from '../../../../lib/types/models/ol/ol'
import { OlContact } from '../../../../lib/types/models/ol/ol-contact'
import { formatPhoneNumber } from '../../../../utils/functions/format-phone-number'
import { generateColumns } from '../../../../utils/functions/generate-columns'
import LabelWithText from '../../ols/label-with-text'

type Props = {
  ol: OlLight
}

export const centerOlContactsColumns = generateColumns<OlContact>({
  order: ['lastName', 'firstName', 'phone', 'email', 'position'],
  headers: {
    lastName: 'Nom',
    firstName: 'Prénom',
    phone: 'Téléphone',
    email: 'Email',
    position: 'Fonction'
  },
  sortableFields: ['lastName', 'firstName', 'email', 'position'],
  customCells: {
    phone: (row) => formatPhoneNumber(row.phone)
  }
})

const CenterOlDetailsSection = ({ ol }: Props) => {
  const { data: olContacts, isPending } = useQuery({
    queryKey: ['ol-other-contacts', ol.id],
    queryFn: async () => getOlOtherContacts(ol.id)
  })

  return (
    <InnerBox className="bg-white-hover rounded-lg">
      <Typography variant="tag" color={tailwindColors.primary.DEFAULT}>
        Détails
      </Typography>
      <div className="h-2" />
      <div className="grid grid-cols-5">
        <LabelWithText label="Nom" data={ol?.mainContactLastName.toUpperCase()} />
        <LabelWithText
          label="Prénom"
          data={
            ol?.mainContactFirstName ? StringFormatter.capitalize(ol.mainContactFirstName) : '-'
          }
        />
        <LabelWithText
          label="Téléphone"
          data={valueRender(ol?.mainContactPhone, (phone) => formatPhoneNumber(phone))}
        />
        <LabelWithText label="Email" data={ol?.mainContactEmail} />
      </div>
      <div className="h-4" />
      <Typography variant="tag" color={tailwindColors.primary.DEFAULT}>
        Autres contacts
      </Typography>
      <div className="h-2" />
      {isPending ? (
        <Loader center />
      ) : (
        <DataTable<OlContact>
          data={olContacts || []}
          paginated={false}
          manualSorting={false}
          mode="normal"
          columns={centerOlContactsColumns}
          rowCount={olContacts ? olContacts.length : 0}
        />
      )}
    </InnerBox>
  )
}

export default CenterOlDetailsSection
